/**
 * Nederlandse teksten (nl-NL), de standaard- en enige launch-taal.
 * Alle gedeelde UI-teksten staan hier zodat een extra taal later alleen een
 * extra bestand met dezelfde structuur vraagt.
 */
export const nl = {
  app: {
    naam: "Webgroeiers Klantportaal",
    korteNaam: "Webgroeiers",
    supportEmail: "support@webgroeiers.nl",
    // TODO: vervangen door het echte supportnummer van Webgroeiers.
    telefoon: "+31301234567",
    telefoonWeergave: "030 - 123 45 67",
  },
  nav: {
    dashboard: "Dashboard",
    aanvragen: "Aanvragen",
    statistieken: "Statistieken",
    advertenties: "Advertenties",
    reviews: "Reviews & Bedrijfsprofiel",
    rapporten: "Rapporten",
    website: "Website & Support",
    instellingen: "Instellingen",
    account: "Mijn account",
    uitloggen: "Uitloggen",
    adminOverzicht: "Klanten",
    auditLog: "Audit-log",
  },
  auth: {
    inloggen: "Inloggen",
    email: "E-mailadres",
    wachtwoord: "Wachtwoord",
    wachtwoordVergeten: "Wachtwoord vergeten?",
    inloggenTitel: "Welkom terug",
    inloggenIntro: "Log in om je website en aanvragen te bekijken.",
    ongeldigeInlog: "Het e-mailadres of wachtwoord klopt niet. Probeer het opnieuw.",
    herstelTitel: "Wachtwoord vergeten",
    herstelIntro:
      "Vul je e-mailadres in. Als het bij ons bekend is, sturen we je een link om een nieuw wachtwoord in te stellen.",
    herstelVerstuurd:
      "Als dit e-mailadres bij ons bekend is, staat er binnen een paar minuten een e-mail in je inbox.",
    herstelKnop: "Stuur herstel-link",
    nieuwWachtwoordTitel: "Nieuw wachtwoord instellen",
    nieuwWachtwoordKnop: "Wachtwoord opslaan",
    terugNaarInloggen: "Terug naar inloggen",
  },
  rollen: {
    superadmin: "Webgroeiers-beheerder",
    owner: "Eigenaar",
    editor: "Medewerker",
    viewer: "Alleen inzien",
  },
  organisatie: {
    status: {
      actief: "Actief",
      gepauzeerd: "Gepauzeerd",
      gearchiveerd: "Gearchiveerd",
    },
    abonnement: {
      basis: "Basis",
      groei: "Groei",
      premium: "Premium",
    },
  },
  modules: {
    dashboard: "Dashboard",
    aanvragen: "Aanvragen",
    statistieken: "Statistieken",
    advertenties: "Advertenties",
    reviews: "Reviews & Bedrijfsprofiel",
    rapporten: "Rapporten",
    website: "Website & Support",
    linkedin: "LinkedIn",
    seo: "Vindbaarheid",
    media: "Media",
    taken: "Taken",
    widget: "AI-assistent",
  },
  leads: {
    status: {
      nieuw: "Nieuw",
      in_behandeling: "In behandeling",
      afgerond: "Afgerond",
      gearchiveerd: "Gearchiveerd",
      spam: "Spam",
    },
  },
  pipeline: {
    stage: {
      nieuw: "Nieuw",
      contact: "In gesprek",
      offerte: "Offerte verstuurd",
      gewonnen: "Gewonnen",
      verloren: "Verloren",
    },
  },
  acquisitie: {
    stage: {
      gescout: "Nieuw",
      demo_gebouwd: "Demo klaar",
      benaderd: "Benaderd",
      gereageerd: "Gereageerd",
      offerte: "Offerte",
      gewonnen: "Gewonnen",
      verloren: "Verloren",
      geen_contact: "Geen contact",
    },
    product: {
      website: "Website",
      webshop: "Webshop",
      marketing: "Marketing",
    },
    subtype: {
      seo: "SEO",
      geo: "GEO",
      sea: "SEA",
    },
    bron: {
      scout: "Gescout",
      netwerk: "Netwerk",
      website: "Website",
      anders: "Anders",
    },
    event: {
      aangemaakt: "Prospect aangemaakt",
      stage_gewijzigd: "Fase gewijzigd",
      demo_toegevoegd: "Demo gepubliceerd",
      outreach_verstuurd: "Eerste mail verstuurd",
      reactie_ontvangen: "Reactie ontvangen",
      geimporteerd: "Geïmporteerd uit het oude CRM",
      klant_aangemaakt: "Klantomgeving aangemaakt",
    },
  },
  agenten: {
    versieStatus: {
      concept: "Concept",
      actief: "Actief",
      gearchiveerd: "Gearchiveerd",
    },
    runStatus: {
      bezig: "Bezig",
      geslaagd: "Geslaagd",
      mislukt: "Mislukt",
      afgebroken: "Afgebroken",
    },
    runTrigger: {
      chat: "Chat",
      widget: "Widget",
      routine: "Routine",
    },
    frequentie: {
      dagelijks: "Dagelijks",
      wekelijks: "Wekelijks",
      maandelijks: "Maandelijks",
      handmatig: "Handmatig",
    },
    capability: {
      read: "Lezen",
      write: "Schrijven",
    },
  },
  verzoeken: {
    status: {
      ontvangen: "Ontvangen",
      in_behandeling: "In behandeling",
      afgerond: "Afgerond",
    },
  },
  taken: {
    status: {
      te_doen: "Te doen",
      bezig: "Bezig",
      wacht_op_klant: "Wacht op jou",
      ter_controle: "Ter controle",
      klaar: "Klaar",
    },
    statusAdmin: {
      te_doen: "Te doen",
      bezig: "Bezig",
      wacht_op_klant: "Wacht op klant",
      ter_controle: "Ter controle",
      klaar: "Klaar",
    },
    type: {
      checklist: "Checklist",
      intern: "Intern",
      verzoek: "Verzoek",
    },
    eigenaar: {
      webgroeiers: "Webgroeiers",
      klant: "Klant",
    },
  },
  facturen: {
    status: {
      draft: "Concept",
      open: "Nog te betalen",
      paid: "Betaald",
      uncollectible: "Te laat",
      void: "Vervallen",
    },
    teLaat: "Te laat",
  },
  impersonatie: {
    banner: (klant: string) =>
      `Je bekijkt dit portaal als ${klant}`,
    terug: "Terug naar admin",
    start: "Bekijk als klant",
  },
  algemeen: {
    opslaan: "Opslaan",
    annuleren: "Annuleren",
    verwijderen: "Verwijderen",
    bezig: "Even geduld…",
    binnenkort: "Binnenkort beschikbaar",
    nietGevonden: "Deze pagina bestaat niet (meer).",
    fout: "Er ging iets mis. Probeer het opnieuw of neem contact op met Webgroeiers.",
  },
} as const;

export type Dictionary = typeof nl;
